const objectStoreUrl = (value) => ({
  endpoint: process.env[value],
});

export const vehicleKMeterObjectUrl = objectStoreUrl(
  "REACT_APP_FILE_FMS_VEHICLE_KMETER"
);
export const vehicleMeterObjectUrl = objectStoreUrl(
  "REACT_APP_FILE_FMS_VEHICLE_METER"
);
export const workingPermitObjectUrl = objectStoreUrl(
  "REACT_APP_FILE_WORKING_PERMIT"
);
export const flowmeterObjectUrl = objectStoreUrl(
  "REACT_APP_FILE_FMS_FLOWMETER"
);
export const operatorObjectUrl = objectStoreUrl("REACT_APP_FILE_FMS_OPERATOR");
export const vehicleObjectUrl = objectStoreUrl("REACT_APP_FILE_FMS_VEHICLE");
export const travelAuthorityObjectUrl = objectStoreUrl("REACT_APP_FILE_TA");
